<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">

                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <div class="delete-button ml-auto d-flex justify-content-center align-items-center gap-2">

                                <button type="button" class="btn btn-danger btn-sm"
                                    @click="statusDeleteMultiple = !statusDeleteMultiple"
                                    v-if="!statusDeleteMultiple">Multiple
                                    Delete</button>

                                <!-- <img src="@/assets/img/icons/delete.svg" alt="img"
                                    @click="showModal('modal_delete_multiple')" v-if="statusDeleteMultiple"
                                    style="cursor: pointer;" />
                                <button type="button" class="btn btn-secondary "
                                    @click="statusDeleteMultiple = !statusDeleteMultiple"
                                    v-if="statusDeleteMultiple">Cancel</button> -->
                                <button class='btn btn-sm btn-danger' @click="showModal('modal_delete_multiple')"
                                    v-if="statusDeleteMultiple" style="cursor: pointer;">Delete</button>
                                <button type="button" class="btn btn-sm btn-secondary "
                                    @click="statusDeleteMultiple = !statusDeleteMultiple"
                                    v-if="statusDeleteMultiple">Cancel</button>
                            </div>
                            <!-- <div class="wordset">
                                <ul>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                                                src="@/assets/img/icons/pdf.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                                                src="@/assets/img/icons/excel.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                                                src="@/assets/img/icons/printer.svg" alt="img" /></a>
                                    </li>
                                </ul>
                            </div> -->

                        </div>
                        <!-- /Filter -->
                        <!-- <div class="card mb-0" id="filter_inputs" :style="{
                            display: filter ? 'block' : 'none',
                        }">
                            <div class="card-body pb-0">
                                <div class="row">
                                    <div class="col-lg-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Product" placeholder="Choose Product" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Choose" placeholder="Choose Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Category" placeholder="Choose Sub Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Brand" placeholder="Brand" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Price" placeholder="Price" />
                                                </div>
                                            </div>
                                            <div class="col-lg-1 col-sm-6 col-12">
                                                <div class="form-group">
                                                    <a class="btn btn-filters ms-auto"><img
                                                            src="@/assets/img/icons/search-whites.svg" alt="img" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- /Filter -->

                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="onChange">
                                <template #bodyCell="{ column, record }">
                                    <!-- Checkbox for selecting rows -->
                                    <template v-if="column.key === 'select' && statusDeleteMultiple">
                                        <input type="checkbox" :checked="selectedItems.includes(record.id)"
                                            @change="toggleSelectRow(record.id)" />
                                    </template>
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'gambar'">
                                        <div class="productimgname">
                                            <a href="javascript:void(0);" class="product-img">
                                                <img :src="record.gambar" alt="product" />
                                            </a>

                                        </div>
                                    </template>

                                    <template v-if="column.key === 'code'">
                                        <div class="productimgname">
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('@/assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);">{{ record.code }}</a>
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'nama_kategori'">
                                        <div class="productimgname">
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('@/assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);">{{ record.nama_kategori }}</a>
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'nama'">
                                        <div class="productimgname">
                                            <!-- <a href="javascript:void(0);" class="product-img">
                                                <img :src="record.gambar" alt="product" />
                                            </a> -->
                                            <a href="javascript:void(0);">{{ record.nama }}</a>
                                        </div>
                                    </template>


                                    <template v-if="column.key === 'rate'">
                                        <div class="productimgname">
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('@/assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);">{{ rupiah(record.rate) }}</a>
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'unit'">
                                        <div class="productimgname">
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('@/assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);">{{ record.unit }}</a>
                                        </div>
                                    </template>

                                    <template v-if="column.key === 'Stock'">
                                        <div class="productimgname">
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('@/assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);">{{ record.stok }}</a>
                                        </div>
                                    </template>

                                    <template v-else-if="column.key === 'action'">
                                        <router-link class="me-3 text-secondary fs-5" to="stock"
                                            @click="stock(record);">
                                            <MDBIcon icon="history" />
                                        </router-link>
                                        <router-link class="me-3" to="editproduct" @click="edit(record);">
                                            <img src="@/assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);" v-if="!statusDeleteMultiple"
                                            @click="terminate(record.id, record.nama); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modal_delete_multiple" ref="modal_delete_multiple" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('modal_delete_multiple')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="deleteMultiple">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('modal_delete_multiple')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, AlertBottom, rupiah, goPage } from "@/assets/js/function";
import { MDBIcon } from "mdb-vue-ui-kit";

export default {
    components: {
        MDBIcon,
    },
    data() {
        return {
            filter: false,
            title: "Product List",
            title1: "Manage your Product",
            items: [
                {
                    text: "Add New Product",
                    addname: "/addproduct",
                },
            ],

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Photo",
                    dataIndex: "gambar",
                    key: "gambar",
                    sorter: {
                        compare: (a, b) => {
                            a = a.gambar.toLowerCase();
                            b = b.gambar.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "SKU",
                    dataIndex: "code",
                    key: "code",
                    sorter: {
                        compare: (a, b) => {
                            a = a.code.toLowerCase();
                            b = b.code.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Category",
                    dataIndex: "nama_kategori",
                    key: "nama_kategori",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_kategori.toLowerCase();
                            b = b.nama_kategori.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Name",
                    dataIndex: "nama",
                    key: "nama",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Price",
                    dataIndex: "rate",
                    key: "rate",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rate.toLowerCase();
                            b = b.rate.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Unit",
                    dataIndex: "unit",
                    key: "unit",
                    sorter: {
                        compare: (a, b) => {
                            a = a.unit.toLowerCase();
                            b = b.unit.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Stock",
                    dataIndex: "stok",
                    key: "stok",
                    sorter: {
                        compare: (a, b) => {
                            a = a.stok.toLowerCase();
                            b = b.stok.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                },
            ],

            statusDeleteMultiple: false,
            status_checklist: false,
            selectedItems: [],


            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",

            //filter
            query: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        this.index();
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                this.rearrangeNumbers();
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            // return this.data.filter(item =>
            //     item.nama.toLowerCase().includes(lowerCaseQuery) ||
            //     item.code.toLowerCase().includes(lowerCaseQuery) ||
            //     (item.nama_kategori && item.nama_kategori.toLowerCase().includes(lowerCaseQuery)) ||
            //     item.unit.toLowerCase().includes(lowerCaseQuery) ||
            //     item.rate.toLowerCase().includes(lowerCaseQuery)

            // );

            const filtered = this.data.filter(item =>
                item.nama.toLowerCase().includes(lowerCaseQuery) ||
                item.code.toLowerCase().includes(lowerCaseQuery) ||
                (item.nama_kategori && item.nama_kategori.toLowerCase().includes(lowerCaseQuery)) ||
                item.unit.toLowerCase().includes(lowerCaseQuery) ||
                item.rate.toLowerCase().includes(lowerCaseQuery)

            );

            filtered.forEach((item, index) => {
                item.no = index + 1; // Assign new sequential number
            });

            return filtered;
        }
    },
    watch: {
        'statusDeleteMultiple': {
            handler(newValue) {
                if (newValue == true) {
                    this.columns.unshift({
                        title: "Check",
                        key: "select",
                        sorter: false
                    });
                } else {
                    // Remove the column with key "select"
                    const index = this.columns.findIndex(column => column.key === "select");
                    if (index !== -1) {
                        this.columns.splice(index, 1); // Remove the column
                    }
                }


            }
        },
    },
    methods: {
        rupiah,
        stock(item) {
            localStorage.setItem('currentDataIndex', JSON.stringify(item));
            goPage('itemsmovement')
        },
        show_izitoast() {
            AlertBottom('tessst');
        },
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },


        // showAlert() {
        //     // Use sweetalert2
        //     Swal.fire({
        //         title: "Are you sure?",
        //         text: "You won't be able to revert this!",
        //         showCancelButton: true,
        //         confirmButtonColor: "#1BA0E2",
        //         cancelButtonColor: "#d33",
        //         confirmButtonText: "Yes, delete it!",
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             Swal.fire("Deleted!", "Your file has been deleted.");
        //         }
        //     });
        // },

        index() {
            ShowLoading();

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'items';
            } else {
                this.api = base_url + 'items';
            }
            axios
                .post(this.api, '', this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        this.data = [];

                        response.data.data.forEach((item, index) => {
                            let item_prepare = { ...item, no: (index + 1), };
                            this.data.push(item_prepare);
                        });
                        console.log(this.data);

                        //save kategori to local
                        localStorage.setItem('kategoriList', JSON.stringify(response.data.data_items_kategori));


                        CloseLoading();
                    }


                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });

        },
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },

        toggleSelectRow(id) {
            const index = this.selectedItems.indexOf(id);
            if (index === -1) {
                // If the item is not in the array, add it
                this.selectedItems.push(id);
            } else {
                // If the item is already in the array, remove it
                this.selectedItems.splice(index, 1);
            }
        },

        rearrangeNumbers() {
            this.data.forEach((item, index) => {
                item.no = index + 1; // Assign new sequential number
            });
        },

        deleteMultiple() {
            if (!this.selectedItems.length) {
                AlertPopup("warning", "", "No items selected for deletion.", 1500, false);

                return;
            }

            ShowLoading();

            let formData = new FormData();

            // Append the selected items to the form data
            // formData.append("id", JSON.stringify(this.selectedItems));
            formData.append("id", this.selectedItems.join(','));

            // for (let pair of formData.entries()) {
            //     console.log(pair[0] + ': ' + pair[1]);
            // }

            // Check the environment to set the API URL
            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'items_multiple_delete';
            } else {
                this.api = base_url + 'items_multiple_delete';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status === true) {
                        // Remove the successfully deleted items from the UI
                        this.selectedItems.forEach((id) => {
                            const index = this.data.findIndex((record) => record.id === id);
                            if (index !== -1) {
                                this.data.splice(index, 1);
                            }
                        });
                        this.rearrangeNumbers();
                        // Clear the selected items array
                        this.selectedItems = [];

                        this.hideModal2('modal_delete_multiple');
                        CloseLoading();
                        AlertBottom(response.data.message);
                    } else {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    CloseLoading();
                    ErrorConnectionTimeOut(error);
                });
        },



        delete2() {
            ShowLoading();
            let formData = new FormData();
            formData.append("id", this.id_terminate);
            formData.append("nama", this.nama_terminate);


            // for (let [key, value] of formData.entries()) {
            //     console.log(`${key}: ${value}`);
            // }

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'items_delete';
            } else {
                this.api = base_url + 'items_delete';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        CloseLoading();
                        AlertBottom(response.data.message);
                        this.hideModal2('terminate');
                    }
                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });


        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>

<style>
.ant-tooltip {
    display: none !important;
}
</style>